// src/App.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Typography,
  Grid,
  Paper,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  FormControlLabel,
  Switch,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactToPrint from 'react-to-print';
import StudentTable from './StudentTable';
import ManageAdvanceDialog from './ManageAdvanceDialog';
import { canteenService } from '../services/canteenService';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { login } from '../redux/admin';
import { loin, logout, updatestudentdata, getdata, updateCanteenPayments } from '../redux/students';
import { getdata_ } from '../redux/class';
import { schooldetails } from '../redux/schooldetails';
import { getCurrencySymbolFromSchool } from '../utils/currencyFormatter';
import { hasSchoolWideStudentListAccess } from '../utils/financeStaffRoles';
import { computeCanteenPeriodReport } from '../utils/canteenPeriodReport';
import {
  getCanteenLedgerRowForDate,
  buildCanteenPaymentPayloadRows,
  buildCanteenUnpaidPayloadRow,
  addConsecutiveDates,
  getStudentAdvancePrepaidTotal,
  listStudentAdvanceEntries,
  normalizeCanteenRecordDateString,
  isSettledCanteenStatus,
  listDatesInclusive,
} from '../utils/canteenLedger';
import { buildApiUrl } from '../config/api';


const initialStudents = [
  { id: 1, name: 'John Doe', amount: '', date: '2024-11-01', class: 'Math', paymentStatus: 'Pending' },
  { id: 2, name: 'Jane Smith', amount: '', date: '2024-11-02', class: 'Science', paymentStatus: 'Pending' },
  { id: 3, name: 'Sam Johnson', amount: '', date: '2024-11-03', class: 'History', paymentStatus: 'Pending' },
  { id: 4, name: 'Alex Lee', amount: '', date: '2024-11-01', class: 'Math', paymentStatus: 'Pending' },
  { id: 5, name: 'Emily Davis', amount: '', date: '2024-11-03', class: 'Science', paymentStatus: 'Pending' },
];

const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

function createData(_id,id,lastname,othernames,status,image, class_, gender, dob,hometown,residence, religion, motherlastname, motherothernames, motheroccupation, mothercontact, motheremail, motherresidence, fatherlastname,fatherothernames, fatheroccupation, fathercontact, fatheremail, fatherresidence, guardianlastname,guardianothernames, guardianoccupation, guardiancontact, guardianemail, guardianresidence, guardianrelationship,  academic ,finance, attendance, Awards, behaviour, others, dailycharge, index, specialID, nextclass, housing) 
{
    return {
        _id,
        id,
        lastname,
        othernames,
        status,
        image,
        class_,
        gender,
        dob,
        hometown,
        residence,
        religion,
        motherlastname,
        motherothernames,
        motheroccupation,
        mothercontact,
        motheremail,
        motherresidence,
        fatherlastname,
        fatherothernames,
        fatheroccupation,
        fathercontact,
        fatheremail,
        fatherresidence, 
        guardianlastname,
        guardianothernames,
        guardianoccupation,
        guardiancontact,
        guardianemail,
        guardianresidence,
        guardianrelationship,
        academic,
        finance,
        attendance,
        Awards,
        behaviour,
        others,
        dailycharge,
        index,
        specialID,
        nextclass,
        housing, 
        
    };
}

function App() {
  const [selected, setSelected] = useState([]);
  const [inputAmount, setInputAmount] = useState('');
  const [filter, setFilter] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDate, setSelectedDate] = useState(getCurrentDate());
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setmessage] = useState("");
  const [stated, setstated] = useState("");
  const [loading, setloading] = useState(false);
  const [opensnack, setOpensnack] = useState(false);
  const [canteenStatus, setCanteenStatus] = useState(null);
  const [setupLoading, setSetupLoading] = useState(false);
  const [studentAmounts, setStudentAmounts] = useState({}); // Store individual student amounts
  const [paymentDate, setPaymentDate] = useState(getCurrentDate);
  const [payInAdvance, setPayInAdvance] = useState(false);
  const [advanceDays, setAdvanceDays] = useState(5);
  const [advanceEndDate, setAdvanceEndDate] = useState(getCurrentDate);
  const [advanceManageStudentId, setAdvanceManageStudentId] = useState(null);
  const [advanceManageLoading, setAdvanceManageLoading] = useState(false);

  const canteenReportPrintRef = useRef(null);
  const [openCanteenReport, setOpenCanteenReport] = useState(false);
  const [canteenPeriodStart, setCanteenPeriodStart] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
  });
  const [canteenPeriodEnd, setCanteenPeriodEnd] = useState(getCurrentDate);
  const [canteenReportClassFilter, setCanteenReportClassFilter] = useState('none');

  // Redux selectors
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const studentsFromRedux = useSelector((state) => state.students);
  const schooldetails_ = useSelector((state) => state.schooldetails);
  const classStateRaw = useSelector((state) => state.class) || [];

  const baseClassList = React.useMemo(() => {
    if (!Array.isArray(classStateRaw)) return [];
    if (classStateRaw.length === 1 && Array.isArray(classStateRaw[0])) return classStateRaw[0];
    return classStateRaw;
  }, [classStateRaw]);

  /** Full class dropdown: school-wide roles merge Redux classes with every class present on students. */
  const Class_ = React.useMemo(() => {
    if (!hasSchoolWideStudentListAccess(admin)) {
      return baseClassList;
    }
    const seen = new Set();
    const out = [];
    for (const c of baseClassList) {
      const name = c?.classname;
      if (name && !seen.has(name)) {
        seen.add(name);
        out.push(c);
      }
    }
    const studList = Array.isArray(studentsFromRedux) ? studentsFromRedux : [];
    for (const s of studList) {
      const name = s?.class_;
      if (name && !seen.has(name)) {
        seen.add(name);
        out.push({ classname: name });
      }
    }
    out.sort((a, b) => String(a.classname || '').localeCompare(String(b.classname || '')));
    return out;
  }, [baseClassList, studentsFromRedux, admin]);
  
  // Get currency symbol from school details
  const currencySymbol = getCurrencySymbolFromSchool(schooldetails_ || []);
  
  // Get the actual schooldetails object (it's an array)
  const schooldetails = schooldetails_?.length > 0 ? schooldetails_[0] : null;
  
  // Filter students by class for teaching staff; school-wide roles see the full list.
  const students = hasSchoolWideStudentListAccess(admin)
    ? studentsFromRedux
    : admin?.class_ === undefined
      ? studentsFromRedux
      : admin?.class_?.length !== 0
        ? studentsFromRedux.filter(student => admin.class_[0].includes(student.class_))
        : studentsFromRedux.filter(student => student.class_ === admin.positiondescription_);



  // Load initial data when component mounts
  useEffect(() => {
    const loadInitialData = async () => {
      if (!students || students.length === 0) {

        // You might want to dispatch an action to load students here
        // For now, we'll use the existing data from Redux
      }
      
      if (!schooldetails && admin?.schoolID) {

        // You might want to dispatch an action to load school details here
      }
    };
    
    loadInitialData();
  }, []);

  // Function to format date for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Enhanced date change handler with backend integration
  const syncAdvanceEndFromStart = (startStr, days) => {
    const start = normalizeCanteenRecordDateString(startStr) || startStr;
    if (!start) return;
    const dates = addConsecutiveDates(start, days);
    setAdvanceEndDate(dates[dates.length - 1]);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    if (payInAdvance) {
      syncAdvanceEndFromStart(newDate, advanceDays);
    }
    fetchCanteenStatus(newDate).catch((error) => {
      console.error('Error fetching canteen status:', error);
    });
  };

  // Fetch canteen status for a specific date
  const fetchCanteenStatus = async (date) => {
    try {
      // Since getCanteenStatus endpoint doesn't exist, use getStudentsWithCanteen
      // and create a mock status response for now
      const students = await canteenService.getStudentsWithCanteen(
        schooldetails?.schoolID || 'default',
        'Active'
      );

      // Create a mock status response based on students data
      const mockStatus = {
        success: true,
        date: date,
        totalStudents: students?.length || 0,
        paidStudents: 0, // TODO: Calculate from actual data
        unpaidStudents: students?.length || 0,
        totalAmount: 0, // TODO: Calculate from actual data
        results: []
      };

      setCanteenStatus(mockStatus);

    } catch (error) {
      console.error('Error fetching canteen status:', error);
      // Don't show error message for missing endpoint - it's expected
      // setmessage("Error fetching canteen status");
      // setstated("error");
      // setOpensnack(true);
      
      // Set empty status instead
      setCanteenStatus({
        success: false,
        date: date,
        totalStudents: 0,
        paidStudents: 0,
        unpaidStudents: 0,
        totalAmount: 0,
        results: []
      });
    }
  };

  // Setup canteen fees for selected class and date
  const handleSetupFees = async () => {
    if (!selectedClass || !inputAmount || !selectedDate) {
      setmessage("Please select class, amount, and date");
      setstated("warning");
      setOpensnack(true);
      return;
    }

    setSetupLoading(true);
    try {
      const data = await canteenService.setupCanteenFees(
        schooldetails?.schoolID || 'default',
        selectedClass,
        inputAmount,
        selectedDate,
        `Daily canteen fee for ${selectedClass}`,
        'admin'
      );

      if (data.success) {
        setmessage(`Canteen fees setup for ${data.studentsAffected} students`);
        setstated("success");
        setOpensnack(true);
        
        // Refresh canteen status
        await fetchCanteenStatus(selectedDate);
        
        // Clear inputs
        setInputAmount('');
        setSelected([]);
      }
    } catch (error) {
      console.error('Error setting up canteen fees:', error);
      setmessage("Error setting up canteen fees");
      setstated("error");
      setOpensnack(true);
    } finally {
      setSetupLoading(false);
    }
  };

  const getPaymentStatusForDate = (student, date) =>
    getCanteenLedgerRowForDate(student, date);

  const mealDateFrom = normalizeCanteenRecordDateString(selectedDate) || selectedDate;
  const mealDateTo =
    normalizeCanteenRecordDateString(advanceEndDate) || mealDateFrom;

  const serviceDatesForPayment = React.useMemo(() => {
    if (!payInAdvance) {
      return mealDateFrom ? [mealDateFrom] : [];
    }
    return listDatesInclusive(mealDateFrom, mealDateTo);
  }, [payInAdvance, mealDateFrom, mealDateTo]);

  const handleAdvanceDaysChange = (rawDays) => {
    const days = Math.max(1, Math.min(31, parseInt(rawDays, 10) || 1));
    setAdvanceDays(days);
    syncAdvanceEndFromStart(selectedDate, days);
  };

  const handleAdvanceEndDateChange = (endStr) => {
    setAdvanceEndDate(endStr);
    if (!mealDateFrom || !endStr) return;
    const range = listDatesInclusive(mealDateFrom, endStr);
    setAdvanceDays(Math.max(1, range.length));
  };

  const handleMarkUnpaid = async (studentIdsOverride, mealDatesOverride) => {
    const targetIds = studentIdsOverride
      ? Array.isArray(studentIdsOverride)
        ? studentIdsOverride
        : [studentIdsOverride]
      : selected;

    if (targetIds.length === 0) {
      setOpenAlert(true);
      return;
    }
    if (!schooldetails?.schoolID) {
      setmessage('School ID not found. Please refresh the page.');
      setstated('error');
      setOpensnack(true);
      return;
    }

    const ledgerDate =
      normalizeCanteenRecordDateString(selectedDate) || selectedDate;
    const mealDates = Array.isArray(mealDatesOverride)
      ? mealDatesOverride
          .map((d) => normalizeCanteenRecordDateString(d) || d)
          .filter(Boolean)
      : [ledgerDate];

    setloading(true);
    try {
      const paymentData = [];
      for (const mongoId of targetIds) {
        const student = students.find((s) => s._id === mongoId);
        if (!student) continue;

        for (const mealDate of mealDates) {
          const row = getPaymentStatusForDate(student, mealDate);
          if (!isSettledCanteenStatus(row.status)) continue;
          const amount = parseFloat(row.amount) || 0;
          const mergeDate = normalizeCanteenRecordDateString(
            row.entry?.date ?? mealDate
          );
          paymentData.push(
            buildCanteenUnpaidPayloadRow(mongoId, mergeDate, amount)
          );
        }
      }

      if (paymentData.length === 0) {
        setmessage(
          'No paid or advance entries found for the selected meal date(s)'
        );
        setstated('warning');
        setOpensnack(true);
        return;
      }

      const data = await canteenService.processPayments(
        paymentData,
        schooldetails.schoolID,
        'Active'
      );

      if (data && (data.success || data.length > 0)) {
        setmessage(`Marked ${paymentData.length} canteen record(s) as unpaid`);
        setstated('success');
        setOpensnack(true);
        dispatch(updateCanteenPayments({ paymentData }));
        setSelected([]);
        await fetchCanteenStatus(selectedDate);
        return true;
      }

      setmessage('Could not mark canteen as unpaid — please try again');
      setstated('error');
      setOpensnack(true);
      return false;
    } catch (error) {
      const errMsg =
        error?.message ||
        error?.response?.data?.message ||
        'Error marking canteen as unpaid';
      setmessage(errMsg);
      setstated('error');
      setOpensnack(true);
      return false;
    } finally {
      setloading(false);
    }
  };

  const advanceManageStudent = React.useMemo(() => {
    if (!advanceManageStudentId) return null;
    return students.find((s) => s._id === advanceManageStudentId) || null;
  }, [advanceManageStudentId, students]);

  const handleOpenAdvanceManage = (studentId) => {
    setAdvanceManageStudentId(studentId);
  };

  const handleCloseAdvanceManage = () => {
    if (advanceManageLoading) return;
    setAdvanceManageStudentId(null);
  };

  const handleRemoveAdvanceMealDates = async (mealDates) => {
    if (!advanceManageStudentId || !mealDates?.length) return;
    if (!schooldetails?.schoolID) {
      setmessage('School ID not found. Please refresh the page.');
      setstated('error');
      setOpensnack(true);
      return;
    }

    setAdvanceManageLoading(true);
    try {
      const paymentData = mealDates
        .map((mealDate) => {
          const student = students.find((s) => s._id === advanceManageStudentId);
          if (!student) return null;
          const row = getPaymentStatusForDate(student, mealDate);
          if (!isSettledCanteenStatus(row.status)) return null;
          const amount = parseFloat(row.amount) || 0;
          const mergeDate = normalizeCanteenRecordDateString(
            row.entry?.date ?? mealDate
          );
          return buildCanteenUnpaidPayloadRow(
            advanceManageStudentId,
            mergeDate,
            amount
          );
        })
        .filter(Boolean);

      if (paymentData.length === 0) {
        setmessage('No advance entries to remove for the selected dates');
        setstated('warning');
        setOpensnack(true);
        return;
      }

      const data = await canteenService.processPayments(
        paymentData,
        schooldetails.schoolID,
        'Active'
      );

      if (data && (data.success || data.length > 0)) {
        dispatch(updateCanteenPayments({ paymentData }));
        setmessage(`Removed ${paymentData.length} advance payment(s)`);
        setstated('success');
        setOpensnack(true);
        await fetchCanteenStatus(selectedDate);
      } else {
        setmessage('Could not remove advance payments — please try again');
        setstated('error');
        setOpensnack(true);
      }
    } catch (error) {
      const errMsg =
        error?.message ||
        error?.response?.data?.message ||
        'Error removing advance payments';
      setmessage(errMsg);
      setstated('error');
      setOpensnack(true);
    } finally {
      setAdvanceManageLoading(false);
    }
  };

  const handleSaveAdvanceEdit = async (mealDate, amount, paymentDateRaw) => {
    if (!advanceManageStudentId || !schooldetails?.schoolID) return;

    const payDate =
      normalizeCanteenRecordDateString(paymentDateRaw) || paymentDateRaw;
    const serviceDate =
      normalizeCanteenRecordDateString(mealDate) || mealDate;

    if (!payDate || !serviceDate || !amount || amount <= 0) {
      setmessage('Please enter a valid amount and payment date');
      setstated('warning');
      setOpensnack(true);
      return false;
    }

    setAdvanceManageLoading(true);
    try {
      const paymentData = buildCanteenPaymentPayloadRows({
        mongoId: advanceManageStudentId,
        amount,
        serviceDates: [serviceDate],
        paymentDate: payDate,
      });

      const data = await canteenService.processPayments(
        paymentData,
        schooldetails.schoolID,
        'Active'
      );

      if (data && (data.success || data.length > 0)) {
        dispatch(updateCanteenPayments({ paymentData }));
        setmessage(`Updated advance payment for ${serviceDate}`);
        setstated('success');
        setOpensnack(true);
        await fetchCanteenStatus(selectedDate);
        return true;
      }

      setmessage('Could not update advance payment — please try again');
      setstated('error');
      setOpensnack(true);
      return false;
    } catch (error) {
      const errMsg =
        error?.message ||
        error?.response?.data?.message ||
        'Error updating advance payment';
      setmessage(errMsg);
      setstated('error');
      setOpensnack(true);
      return false;
    } finally {
      setAdvanceManageLoading(false);
    }
  };

  // Enhanced payment handler with backend integration
  const handlePayment = async () => {
    if (selected.length === 0) {
      setOpenAlert(true);
      return;
    }

    const hasValidAmounts = selected.some((studentId) => {
      const amount = studentAmounts[studentId] || inputAmount;
      return amount && amount > 0;
    });

    if (!hasValidAmounts) {
      setmessage("Please enter valid amounts for selected students or use 'Apply Amount' button");
      setstated("warning");
      setOpensnack(true);
      return;
    }

    if (!schooldetails?.schoolID) {
      setmessage("School ID not found. Please refresh the page.");
      setstated("error");
      setOpensnack(true);
      return;
    }

    if (!students || students.length === 0) {
      setmessage("No students data available. Please refresh the page.");
      setstated("error");
      setOpensnack(true);
      return;
    }

    const payDate = normalizeCanteenRecordDateString(paymentDate) || paymentDate;
    if (!payDate) {
      setmessage('Please select a valid payment (cash) date');
      setstated('warning');
      setOpensnack(true);
      return;
    }

    if (payInAdvance && serviceDatesForPayment.length === 0) {
      setmessage('Please select valid meal dates (from and to)');
      setstated('warning');
      setOpensnack(true);
      return;
    }

    setloading(true);

    try {
      const paymentData = [];
      for (const mongoId of selected) {
        const student = students.find((s) => s._id === mongoId);
        if (!student) continue;
        const studentAmount = studentAmounts[mongoId] || inputAmount;
        if (!studentAmount || studentAmount <= 0) continue;
        const rows = buildCanteenPaymentPayloadRows({
          mongoId,
          amount: parseFloat(studentAmount),
          serviceDates: serviceDatesForPayment,
          paymentDate: payDate,
        });
        paymentData.push(...rows);
      }

      if (paymentData.length === 0) {
        setmessage('No valid payments to process');
        setstated('warning');
        setOpensnack(true);
        return;
      }

      const data = await canteenService.processPayments(
        paymentData,
        schooldetails?.schoolID || 'default',
        'Active'
      );

      if (data && (data.success || data.length > 0)) {
        const advanceCount = paymentData.filter(
          (p) => p.data?.canteen?.status === 'Advance'
        ).length;
        const successMessage =
          payInAdvance && serviceDatesForPayment.length > 1
            ? `Paid ${serviceDatesForPayment.length} meal dates (${mealDateFrom} to ${mealDateTo})${
                advanceCount > 0 ? ` — ${advanceCount} as advance` : ''
              }`
            : advanceCount > 0
              ? `Processed ${paymentData.length} ledger row(s) (${advanceCount} advance)`
              : data.message || `Successfully processed ${paymentData.length} payment(s)`;
        setmessage(successMessage);
        setstated("success");
        setOpensnack(true);
        
        dispatch(updateCanteenPayments({ paymentData }));
        
        setSelected([]);
        setInputAmount('');
        
        await fetchCanteenStatus(selectedDate);
        
      } else {
        setmessage("Error processing payments - invalid response from server");
        setstated("error");
        setOpensnack(true);
      }
    } catch (error) {
      console.error('🚨 Payment processing failed:', error);
      console.error('🚨 Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config?.url,
        details: error.details
      });
      
      // Enhanced error messaging with better error handling
      let errorMessage = "Error processing payments";
      
      // Check if it's our enhanced error object
      if (error.message && error.details) {
        errorMessage = error.message;
        console.error('🚨 Enhanced error details:', error.details);
      } else if (error.message.includes('Server is not running')) {
        errorMessage = "Local server is not running. Please start the server first.";
      } else if (error.response?.status === 500) {
        errorMessage = "Server error. Please check server logs.";
      } else if (error.response?.status === 404) {
        errorMessage = "Payment endpoint not found. Please check server configuration.";
      } else if (error.message.includes('Network Error')) {
        errorMessage = "Network error. Please check your connection and server status.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setmessage(errorMessage);
      setstated("error");
      setOpensnack(true);
    } finally {
      setloading(false);
    }
  };

  // Enhanced amount application handler
  const handleApplyAmount = () => {
    if (selected.length === 0) {
      setOpenAlert(true);
      return;
    }

    if (!inputAmount || inputAmount <= 0) {
      setmessage("Please enter a valid amount");
      setstated("warning");
      setOpensnack(true);
      return;
    }


    // Create temporary amounts object for selected students
    const tempAmounts = {};
    selected.forEach(studentId => {
      tempAmounts[studentId] = inputAmount;
    });

    // Store amounts in local state for table display
    setStudentAmounts(prev => ({
      ...prev,
      ...tempAmounts
    }));
    
    setmessage(`Amount ${currencySymbol} ${inputAmount} applied to ${selected.length} students`);
    setstated("success");
    setOpensnack(true);
    
  };

  const handleAmountChange = (studentId, value) => {
    
    // Update the student amounts in local state
    setStudentAmounts(prev => ({
      ...prev,
      [studentId]: value
    }));
  };


  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenAlert(false);
  };


  const handleClicksnack = () => {
    setOpensnack(true);
};


const handleClosesnack = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setOpensnack(false);
};

const paymentlist=()=>{
var total=0
  for(var i in students){
    for (var k in students[i].canteen){
      total+=parseFloat(students[i].canteen[k].amount)
    }
  }
return total
}

  // Fetch canteen status when component mounts or date/class changes
  useEffect(() => {
    if (selectedDate) {
      fetchCanteenStatus(selectedDate);
    }
  }, [selectedDate, selectedClass]);

  // Enhanced Redux data extraction with better error handling (already done above)
  // const admin = useSelector((state) => state.admin);
  // const stud = useSelector((state) => state.students);
  // const Class_ = useSelector((state) => state.class);
  // const schooldetails = useSelector((state) => state.schooldetails);

  // Remove duplicate student processing - we already have students from Redux above
  // const schools = stud || [];
  // const data = [schools.map((list, index) => createData(...))];
  // const students_ = data[0] || [];
  // const [students, setStudents] = useState(students_);
  
  // Use setStudents for updating the students state if needed
  const [studentsState, setStudents] = useState([]);

  // Enhanced filtered students with better performance
  const filteredStudents = React.useMemo(() => {
    if (!students || students.length === 0) return [];
    const q = filter.trim().toLowerCase();
    const idNeedle = filter.trim();
    return students.filter(
      (student) =>
        ((student.lastname && student.lastname.toLowerCase().includes(q)) ||
          (student.othernames && student.othernames.toLowerCase().includes(q)) ||
          (student.ID != null && student.ID.toString().includes(idNeedle))) &&
        (selectedClass === '' || student.class_ === selectedClass)
    );
  }, [students, filter, selectedClass]);

  // Enhanced canteen statistics calculation
  const canteenStats = React.useMemo(() => {
    if (!filteredStudents.length) return null;

    const totalStudents = filteredStudents.length;
    let paidStudents = 0;
    let advanceOnDate = 0;
    let unpaidStudents = 0;
    let totalCollectedOnDate = 0;
    let totalAdvancePrepaid = 0;
    const payToday = normalizeCanteenRecordDateString(paymentDate) || paymentDate;

    filteredStudents.forEach((student) => {
      const row = getPaymentStatusForDate(student, selectedDate);
      if (row.status === 'Paid') {
        paidStudents += 1;
        totalCollectedOnDate += parseFloat(row.amount) || 0;
      } else if (row.status === 'Advance') {
        advanceOnDate += 1;
        totalCollectedOnDate += parseFloat(row.amount) || 0;
      } else {
        unpaidStudents += 1;
      }
      totalAdvancePrepaid += getStudentAdvancePrepaidTotal(student, selectedDate);
    });

    const cashCollectedToday = filteredStudents.reduce((sum, student) => {
      if (!student.canteen?.length) return sum;
      return (
        sum +
        student.canteen.reduce((inner, entry) => {
          const pd = normalizeCanteenRecordDateString(
            entry.paymentDate || entry.date
          );
          if (pd !== payToday) return inner;
          const st = String(entry.status || '').toLowerCase();
          if (st === 'paid' || st === 'advance') {
            return inner + (parseFloat(entry.amount) || 0);
          }
          return inner;
        }, 0)
      );
    }, 0);

    const expectedAmountPerStudent = inputAmount ? parseFloat(inputAmount) : 5.0;
    const coveredCount = paidStudents + advanceOnDate;
    const collectionRate =
      totalStudents > 0 ? Math.round((coveredCount / totalStudents) * 100) : 0;
    const averagePayment = coveredCount > 0 ? totalCollectedOnDate / coveredCount : 0;
    const pendingAmount = unpaidStudents * expectedAmountPerStudent;

    return {
      totalStudents,
      paidStudents,
      advanceOnDate,
      unpaidStudents,
      totalAmount: totalCollectedOnDate,
      cashCollectedToday,
      totalAdvancePrepaid,
      collectionRate,
      averagePayment,
      pendingAmount,
      expectedAmountPerStudent,
    };
  }, [filteredStudents, selectedDate, inputAmount, paymentDate]);

  const canteenReportComputed = React.useMemo(
    () =>
      computeCanteenPeriodReport(
        Array.isArray(students) ? students : [],
        canteenReportClassFilter,
        canteenPeriodStart,
        canteenPeriodEnd
      ),
    [students, canteenReportClassFilter, canteenPeriodStart, canteenPeriodEnd]
  );

  const closeCanteenReport = () => setOpenCanteenReport(false);

  const openCanteenReportDialog = () => {
    setCanteenReportClassFilter(selectedClass ? selectedClass : 'none');
    setOpenCanteenReport(true);
  };

  const handleSelect = (studentId) => {
    setSelected((prevSelected) =>
      prevSelected.includes(studentId)
        ? prevSelected.filter((id) => id !== studentId)
        : [...prevSelected, studentId]
    );
  };

  const handleSelectAll = useCallback((checked, visibleStudentIds) => {
    if (checked) {
      setSelected((prev) => [...new Set([...prev, ...visibleStudentIds])]);
    } else {
      setSelected((prev) => prev.filter((id) => !visibleStudentIds.includes(id)));
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }}>

       <Snackbar open={opensnack} autoHideDuration={6000} onClose={handleClosesnack}>
                      <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                          { message }
                      </Alert>
                  </Snackbar>
            <Paper sx={{ width: '100%', mb: 2 }}>

<div style={{padding:"20px"}}>
    <p style={{textAlign:"center", fontWeight:"bolder"}}>CANTEEN FEES</p>
    <Divider/>
</div>

{/* Single Comprehensive Dashboard Card */}

    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px', padding:"10px", flexWrap: 'wrap' }}>
       
        <TextField
          label="Search Students"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          variant="outlined"
          size="small"
        />

        <FormControl variant="outlined" size="small" style={{ minWidth: '150px' }}>
          <InputLabel>Class</InputLabel>
          <Select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            label="Class"
          >
            <MenuItem value="">All</MenuItem>
         
          {Class_ && Array.isArray(Class_) && Class_.length !== 0 ? 
            Class_.map((list, index) => (
              <MenuItem key={index} value={list.classname}>
                {list.classname}
              </MenuItem>
            )) : 
            <MenuItem disabled>No classes available</MenuItem>
          }
         
         </Select>
        </FormControl>

        <TextField
        label={payInAdvance ? 'Meal date from' : 'Meal / ledger date'}
        type="date"
        value={selectedDate}
        onChange={(e) => handleDateChange(e.target.value)}
        variant="outlined"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        style={{ minWidth: '150px' }}
      />

        {payInAdvance && (
          <TextField
            label="Meal date to"
            type="date"
            value={advanceEndDate}
            onChange={(e) => handleAdvanceEndDateChange(e.target.value)}
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: selectedDate }}
            style={{ minWidth: '150px' }}
          />
        )}

        <TextField
          label="Payment (cash) date"
          type="date"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
          style={{ minWidth: '150px' }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={payInAdvance}
              onChange={(e) => {
                const on = e.target.checked;
                setPayInAdvance(on);
                if (on) {
                  syncAdvanceEndFromStart(selectedDate, advanceDays);
                }
              }}
              color="primary"
            />
          }
          label="Pay for date range (advance)"
        />

        {payInAdvance && (
          <>
            <TextField
              label="Number of days"
              type="number"
              size="small"
              value={advanceDays}
              onChange={(e) => handleAdvanceDaysChange(e.target.value)}
              inputProps={{ min: 1, max: 31 }}
              style={{ width: 120 }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 280 }}>
              Covers {serviceDatesForPayment.length} day(s):{' '}
              {mealDateFrom}
              {serviceDatesForPayment.length > 1 ? ` → ${mealDateTo}` : ''}
            </Typography>
          </>
        )}

        <TextField
          label="Set Amount for Selected Students"
          value={inputAmount}
          size='small'
          onChange={(e) => setInputAmount(e.target.value)}
          type="number"
          inputProps={{ min: 0, step: 0.01 }}
        />

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSetupFees}
          disabled={setupLoading || !selectedClass || !inputAmount || !selectedDate}
          startIcon={setupLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {setupLoading ? 'Setting Up...' : 'Setup Fees'}
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleApplyAmount}
          disabled={selected.length === 0 || !inputAmount}
        >
          Apply Amount
        </Button> 
        
        <Button
          variant="contained"
          color="success"
          onClick={handlePayment}
          disabled={
            loading ||
            selected.length === 0 ||
            (!inputAmount && !selected.some((id) => studentAmounts[id]))
          }
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
         {loading ? 'Processing...' : 'Submit Payment'}
        </Button>

        <Button
          variant="contained"
          color="warning"
          onClick={() => handleMarkUnpaid()}
          disabled={
            loading ||
            selected.length === 0 ||
            !selected.some((id) => {
              const student = students?.find((s) => s._id === id);
              if (!student) return false;
              return isSettledCanteenStatus(
                getPaymentStatusForDate(student, selectedDate).status
              );
            })
          }
        >
          Mark as Unpaid
        </Button>

        <Button variant="outlined" color="primary" onClick={openCanteenReportDialog}>
          Paid / unpaid report (period)
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            setCanteenReportClassFilter('none');
            setOpenCanteenReport(true);
          }}
        >
          Report: all classes
        </Button>
      </div>

      {/* Enhanced Payment Summary for Selected Date */}
      <div style={{ 
        padding: '20px', 
        margin: '10px 0', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <Typography variant="h6" style={{ marginBottom: '15px', color: '#1976d2' }}>
          Payment Summary for {formatDateForDisplay(selectedDate)}
          {canteenStatus && (
            <span style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
              (Last updated: {new Date().toLocaleTimeString()})
            </span>
          )}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#1a7f37', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.paidStudents : 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Paid (this meal date)
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#ed6c02', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.advanceOnDate : 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Advance (this date)
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#d14343', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.unpaidStudents : 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Unpaid
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#1976d2', fontWeight: 'bold' }}>
                {currencySymbol}{' '}
                {canteenStats ? canteenStats.cashCollectedToday.toFixed(2) : '0.00'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Cash collected (payment date)
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#6a1b9a', fontWeight: 'bold' }}>
                {currencySymbol}{' '}
                {canteenStats ? canteenStats.totalAdvancePrepaid.toFixed(2) : '0.00'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Prepaid (future meals)
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#856404', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.totalStudents : filteredStudents.length}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Students
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </div>

  

      {/* Quick Actions for Unpaid Students */}
      <div style={{ 
        padding: '15px 20px', 
        margin: '10px 0', 
        backgroundColor: '#fff3cd', 
        borderRadius: '8px',
        border: '1px solid #ffeaa7'
      }}>
        <Typography variant="subtitle1" style={{ marginBottom: '10px', color: '#856404', fontWeight: '500' }}>
          Quick Actions
        </Typography>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', color: '#856404' }}>
            Unpaid students: {canteenStats ? canteenStats.unpaidStudents : 
              filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return status.status === 'Unpaid';
              }).length}
          </span>
          <Button
            variant="outlined"
            size="small"
            color="warning"
            onClick={() => {
              const unpaidStudents = filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return status.status === 'Unpaid';
              });
              setSelected(unpaidStudents.map(s => s._id));
            }}
          >
            Select All Unpaid
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="success"
            onClick={() => {
              const paidStudents = filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return isSettledCanteenStatus(status.status);
              });
              setSelected(paidStudents.map(s => s._id));
            }}
          >
            Select All Paid / Advance
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="warning"
            disabled={loading}
            onClick={() => handleMarkUnpaid()}
          >
            Mark selected as unpaid
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="info"
            onClick={() => {
              setSelected([]);
              setInputAmount('');
            }}
          >
            Clear Selection
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="secondary"
            onClick={() => fetchCanteenStatus(selectedDate)}
          >
            Refresh Status
          </Button>
        </div>
      </div>

      <StudentTable
        students={filteredStudents}
        selected={selected}
        handleSelect={handleSelect}
        handleAmountChange={handleAmountChange}
        handleSelectAll={handleSelectAll}
        handlePayment={handlePayment}
        handleMarkUnpaid={handleMarkUnpaid}
        onManageAdvance={handleOpenAdvanceManage}
        selectedDate={selectedDate}
        getPaymentStatusForDate={getPaymentStatusForDate}
        getStudentAdvancePrepaidTotal={getStudentAdvancePrepaidTotal}
        listStudentAdvanceEntries={listStudentAdvanceEntries}
        canteenStatus={canteenStatus}
        studentAmounts={studentAmounts}
        currencySymbol={currencySymbol}
      />

      <ManageAdvanceDialog
        open={!!advanceManageStudentId}
        onClose={handleCloseAdvanceManage}
        student={advanceManageStudent}
        asOfDate={selectedDate}
        currencySymbol={currencySymbol}
        loading={advanceManageLoading}
        onRemoveMealDates={handleRemoveAdvanceMealDates}
        onSaveEdit={handleSaveAdvanceEdit}
      />

      <Dialog fullWidth maxWidth="lg" open={openCanteenReport} onClose={closeCanteenReport}>
        <DialogTitle
          style={{
            backgroundImage: 'linear-gradient(315deg, #17dddd 0%, #1760d3 74%)',
            color: 'white',
          }}
        >
          Canteen — paid / unpaid (by class and period)
          <IconButton onClick={closeCanteenReport} style={{ float: 'right' }}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Stack direction="row" flexWrap="wrap" gap={2} alignItems="center" sx={{ mb: 2 }}>
              <TextField
                label="From"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={canteenPeriodStart}
                onChange={(e) => setCanteenPeriodStart(e.target.value)}
              />
              <TextField
                label="To"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={canteenPeriodEnd}
                onChange={(e) => setCanteenPeriodEnd(e.target.value)}
              />
              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="canteen-report-class-app">Class</InputLabel>
                <Select
                  labelId="canteen-report-class-app"
                  label="Class"
                  value={canteenReportClassFilter}
                  onChange={(e) => setCanteenReportClassFilter(e.target.value)}
                >
                  <MenuItem value="none">
                    <em>All classes</em>
                  </MenuItem>
                  {Class_.filter((c) => c && c.classname).map((c) => (
                    <MenuItem key={c.classname} value={c.classname}>
                      {c.classname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <ReactToPrint
                pageStyle="@page { size: A4; margin: 10mm; } @media print { body { font-size: 10pt; } }"
                trigger={() => (
                  <Button variant="contained" color="primary">
                    Print report
                  </Button>
                )}
                content={() => canteenReportPrintRef.current}
              />
          </Stack>

          <div ref={canteenReportPrintRef}>
            <div style={{ textAlign: 'center', marginBottom: 12 }}>
              <img
                src={
                  schooldetails_?.length > 0 && schooldetails_[0].image
                    ? buildApiUrl(`/routes/logothumb/${encodeURIComponent(schooldetails_[0].image)}`)
                    : undefined
                }
                width="72px"
                alt=""
              />
              <br />
              <Typography component="h4" sx={{ m: 0.5 }}>
                {(schooldetails_?.length > 0 && schooldetails_[0].schoolname
                  ? schooldetails_[0].schoolname
                  : ''
                ).toUpperCase()}
              </Typography>
              <Typography component="h6" variant="body2" sx={{ m: 0.5 }}>
                {(schooldetails_?.length > 0 && schooldetails_[0].address
                  ? schooldetails_[0].address
                  : ''
                ).toUpperCase()}
              </Typography>
              <Typography component="h3" variant="h6" sx={{ m: 1 }}>
                Canteen report
              </Typography>
              <Typography variant="body2">
                Period: {canteenPeriodStart} to {canteenPeriodEnd}
                {canteenReportClassFilter && canteenReportClassFilter !== 'none'
                  ? ` · Class: ${canteenReportClassFilter}`
                  : ' · All classes'}
              </Typography>
            </div>

            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Revenue earned (meal dates in period)
                  </Typography>
                  <Typography variant="h6">
                    {currencySymbol}{' '}
                    {Intl.NumberFormat('en-US').format(
                      parseFloat((canteenReportComputed.totalPaid || 0).toFixed(2))
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Cash collected (payment dates in period)
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {currencySymbol}{' '}
                    {Intl.NumberFormat('en-US').format(
                      parseFloat((canteenReportComputed.totalCashCollected || 0).toFixed(2))
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Advance payments (cash in period, meal later)
                  </Typography>
                  <Typography variant="h6" sx={{ color: '#ed6c02' }}>
                    {currencySymbol}{' '}
                    {Intl.NumberFormat('en-US').format(
                      parseFloat((canteenReportComputed.totalAdvance || 0).toFixed(2))
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Unpaid / owing (meal dates in period)
                  </Typography>
                  <Typography variant="h6" color="error">
                    {currencySymbol}{' '}
                    {Intl.NumberFormat('en-US').format(
                      parseFloat((canteenReportComputed.totalUnpaid || 0).toFixed(2))
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Students with paid / advance meals
                  </Typography>
                  <Typography variant="h6">{canteenReportComputed.studentCountPaid}</Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Students with unpaid lines
                  </Typography>
                  <Typography variant="h6">{canteenReportComputed.studentCountUnpaid}</Typography>
                </Grid>
              </Grid>
            </Paper>

            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              Paid lines ({canteenReportComputed.paidLines.length})
            </Typography>
            <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>No.</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Student</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Class</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Note</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {canteenReportComputed.paidLines.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No paid canteen entries in this range.
                      </TableCell>
                    </TableRow>
                  ) : (
                    canteenReportComputed.paidLines.map((line, idx) => (
                      <TableRow key={`p-${idx}-${line.studentSchoolId}-${line.date}`}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{line.studentName}</TableCell>
                        <TableCell>{line.studentSchoolId}</TableCell>
                        <TableCell>{line.className}</TableCell>
                        <TableCell>{line.date}</TableCell>
                        <TableCell align="right">
                          {currencySymbol}{' '}
                          {Intl.NumberFormat('en-US').format(parseFloat((line.amount || 0).toFixed(2)))}
                        </TableCell>
                        <TableCell>{line.description || line.status || '—'}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              Advance payments — cash received in period ({canteenReportComputed.advanceLines.length})
            </Typography>
            <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>No.</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Student</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Class</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Cash date</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Meal date</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Note</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {canteenReportComputed.advanceLines.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No advance canteen payments in this period.
                      </TableCell>
                    </TableRow>
                  ) : (
                    canteenReportComputed.advanceLines.map((line, idx) => (
                      <TableRow key={`a-${idx}-${line.studentSchoolId}-${line.date}`}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{line.studentName}</TableCell>
                        <TableCell>{line.studentSchoolId}</TableCell>
                        <TableCell>{line.className}</TableCell>
                        <TableCell>{line.paymentDate}</TableCell>
                        <TableCell>{line.date}</TableCell>
                        <TableCell align="right">
                          {currencySymbol}{' '}
                          {Intl.NumberFormat('en-US').format(parseFloat((line.amount || 0).toFixed(2)))}
                        </TableCell>
                        <TableCell>{line.description || 'Advance'}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              Unpaid / owing lines ({canteenReportComputed.unpaidLines.length})
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>No.</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Student</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Class</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Meal date</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Owing
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Note</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {canteenReportComputed.unpaidLines.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No unpaid students in this period (everyone paid or no students in class filter).
                      </TableCell>
                    </TableRow>
                  ) : (
                    canteenReportComputed.unpaidLines.map((line, idx) => (
                      <TableRow key={`u-${idx}-${line.studentSchoolId}-${line.date}`}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{line.studentName}</TableCell>
                        <TableCell>{line.studentSchoolId}</TableCell>
                        <TableCell>{line.className}</TableCell>
                        <TableCell>{line.date}</TableCell>
                        <TableCell align="right">
                          {currencySymbol}{' '}
                          {Intl.NumberFormat('en-US').format(parseFloat((line.amount || 0).toFixed(2)))}
                        </TableCell>
                        <TableCell>{line.description || line.status || '—'}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCanteenReport} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="warning" sx={{ width: '100%' }}>
          Please select at least one student to apply the amount.
        </Alert>
      </Snackbar>



    </Paper>
     
    </Box>
  );
}

export default App;
